import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { BillingPage } from '../modules/billing/ui/pages/BillingPage';

// ── Search params schema ───────────────────────────────────────────────────────
//
// REQ-10.2: read ?connected and ?error from the OAuth redirect URL on initial
// page load — no separate API call needed for the redirect-triggered transition.

const billingSearchSchema = z.object({
  connected: z.string().optional(),
  error: z.string().optional(),
});

// ── Route ──────────────────────────────────────────────────────────────────────

export const Route = createFileRoute('/_authenticated/dashboard/settings/billing/')({
  validateSearch: (search: Record<string, unknown>) =>
    billingSearchSchema.parse({
      connected: typeof search.connected === 'string' ? search.connected : undefined,
      error: typeof search.error === 'string' ? search.error : undefined,
    }),
  component: BillingRoute,
  staticData: {
    breadcrumb: ['Manage', 'Settings', 'Billing'],
  },
});

function BillingRoute() {
  const { connected, error } = Route.useSearch();
  return <BillingPage connected={connected} error={error} />;
}
